import { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import PhotoCapture from "@/components/gate/PhotoCapture";

const PURPOSES = [["service", "Service walk-in"], ["delivery", "Delivery / Stock"], ["visitor", "Visitor"], ["staff", "Staff"], ["other", "Other"]];
const EMPTY = { direction: "in", vehicle_reg_no: "", purpose: "service", notes: "" };

// Records any vehicle crossing the gate without a pass.
export default function GateVehicleLog({ onSaved }) {
  const [form, setForm] = useState(EMPTY);
  const [photo, setPhoto] = useState(null);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const fd = new FormData();
      Object.entries(form).forEach(([k, v]) => fd.append(k, v));
      fd.append("photo", photo);
      await api.post("/gate-passes/log", fd);
      toast.success(`${form.vehicle_reg_no.toUpperCase()} logged ${form.direction === "in" ? "IN" : "OUT"}`);
      setForm({ ...EMPTY, direction: form.direction });
      setPhoto(null);
      onSaved();
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={save} className="space-y-3" data-testid="gate-log-form">
      <div className="grid grid-cols-2 border border-ink">
        {[["in", "Coming IN"], ["out", "Going OUT"]].map(([v, l]) => (
          <button key={v} type="button" onClick={() => setForm((f) => ({ ...f, direction: v }))} data-testid={`gate-log-dir-${v}`}
            className={`py-3 text-sm font-bold ${form.direction === v ? "bg-ink text-white" : "bg-canvas"}`}>{l}</button>
        ))}
      </div>
      <input value={form.vehicle_reg_no} onChange={set("vehicle_reg_no")} placeholder="Vehicle number e.g. AP05AB1234" required
        data-testid="gate-log-vehicle" className="w-full px-3 py-3 border border-canvas-line text-base font-mono uppercase" />
      <select value={form.purpose} onChange={set("purpose")} data-testid="gate-log-purpose" className="w-full px-3 py-3 border border-canvas-line text-sm bg-canvas">
        {PURPOSES.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
      </select>
      <input value={form.notes} onChange={set("notes")} placeholder="Notes (optional)" data-testid="gate-log-notes"
        className="w-full px-3 py-3 border border-canvas-line text-sm" />
      <PhotoCapture value={photo} onChange={setPhoto} testId="gate-log-photo" />
      <button type="submit" disabled={busy || !photo || form.vehicle_reg_no.trim().length < 2} data-testid="gate-log-submit"
        className="w-full py-4 bg-ink text-white font-bold disabled:opacity-40">{busy ? "Saving…" : "Save entry"}</button>
    </form>
  );
}
